import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Yellow_Btn.css";

const Yellow_Btn = ({
  rightIcon,
  leftIcon,
  disabled,
  onClick,
  btnText,
  type = "button",
  className = "",
}) => {
  return (
    <button
      className={`Yellow_Btn ${className}`.trim()}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {leftIcon && (
        <span className="icon_holder">
          <FontAwesomeIcon icon={leftIcon} className="left_icon" />
        </span>
      )}

      <span className="btn_text">{btnText}</span>

      {rightIcon && (
        <span className="icon_holder">
          <FontAwesomeIcon icon={rightIcon} className="right_icon" />
        </span>
      )}
    </button>
  );
};

export default Yellow_Btn;
